import React, { useContext, useState, ReactNode } from 'react';

import Header from '../components/Header';
import { SidebarV2 } from '../components/SidebarV2';
import BackgroundJobRail from '../components/BackgroundJobs/BackgroundJobRail';
import SidebarDesktopToggle from '../components/SidebarV2/SidebarDesktopToggle';
import LayoutPersistenceContext from './LayoutPersistenceContext';
import { getInitialSidebarExpanded } from '../utils/sidebarPreference';

const DefaultLayout: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const hasPersistentLayout = useContext(LayoutPersistenceContext);
  // =====================================================
  // 🔹 Mobile Overlay
  // =====================================================
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // =====================================================
  // 🔹 Desktop Sidebar
  // =====================================================
  const [sidebarExpanded, setSidebarExpanded] = useState(() =>
    getInitialSidebarExpanded(true)
  );

  if (hasPersistentLayout) return <>{children}</>;

  return (
    <LayoutPersistenceContext.Provider value>
      <div className="dark:bg-boxdark-2 dark:text-bodydark">
        {/* ===================================================== */}
        {/* 🔹 Page Wrapper */}
        {/* ===================================================== */}
        <div className="relative flex h-screen overflow-hidden">
          {/* ===================================================== */}
          {/* 🔹 Sidebar */}
          {/* ===================================================== */}
          <SidebarV2
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            sidebarExpanded={sidebarExpanded}
            setSidebarExpanded={setSidebarExpanded}
          />

          <SidebarDesktopToggle
            expanded={sidebarExpanded}
            onToggle={() => setSidebarExpanded((expanded) => !expanded)}
          />

          {/* ===================================================== */}
          {/* 🔹 Content Area */}
          {/* ===================================================== */}
          <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
            {/* ===================================================== */}
            {/* 🔹 Header */}
            {/* ===================================================== */}
            <Header
              sidebarOpen={sidebarOpen}
              setSidebarOpen={setSidebarOpen}
              sidebarExpanded={sidebarExpanded}
              setSidebarExpanded={setSidebarExpanded}
            />

            {/* ===================================================== */}
            {/* 🔹 Main */}
            {/* ===================================================== */}
            <main>
              <div className="mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10">
                {children}
              </div>
            </main>

            <BackgroundJobRail />
          </div>
        </div>
      </div>
    </LayoutPersistenceContext.Provider>
  );
};

export default DefaultLayout;
